export const environment = {
  production: true,
  authenticated: false,
  hmr: false,
  ezlab_url: "ezlab-api.easybox.io",
  websocketSchema: 'wss',
  schema: 'https',
  app: 'Ezlab',
  customerSiteName: "Easybox",
  logo: 'assets/images/easybox/logo.svg',
  favi: 'assets/images/cadlab/favicon.ico',
  appVersion: '1.1.18',
  firebaseConfig: {
    apiKey: "AIzaSyBQ2PJRy-gCw6g2tqhhOzn_ZhQpNfe08e0",
    authDomain: "ezlab-8c884.firebaseapp.com",
    projectId: "ezlab-8c884",
    storageBucket: "ezlab-8c884.firebasestorage.app",
    messagingSenderId: "355357405437",
    appId: "1:355357405437:web:54842fd2e4e82706380e94",
    measurementId: "G-TFX8WE7Q4T"
  },
  vapidKey: "BDTtuqAZKw_iKuKIeOOpFsexpixGxdyoVP7s2fg_6_v_FYPia4SjwepuvMSb58ef9Mq6PVIKYU5jRpZMOzIJmCo"
}

export const VERSION = {
  name: '1.0.0',
}
